import { Injectable, inject } from "@angular/core";
import { delayWhen, filter, first } from "rxjs/operators";
import { isNotNullOrUndefined } from "@pcp/core/util";
import { Store } from "@ngrx/store";
import { StreamingHubService } from "@pcp/streaming";
import * as fromLesson from "../store/lesson.selectors";

@Injectable({
    providedIn: 'root',
})
export class ClassroomEffectsHelperService {

    private readonly store = inject(Store);
    private readonly hub = inject(StreamingHubService);

    private readonly lessonId$ = this.store.select(fromLesson.selectLessonIdOrLiveLessonId);
    readonly hasLessonId$ = this.lessonId$.pipe(filter(isNotNullOrUndefined));
    readonly hasNoLessonId$ = this.lessonId$.pipe(filter((lessonId) => lessonId === undefined));

    readonly hasLessonIdAndIsConnected$ = this.hasLessonId$.pipe(
        delayWhen(() => this.hub.isConnected$.pipe(first(connected => connected)))
    );
}
